import { capitalizeWords } from '@zoocasa/node-kit/strings/capitalize';

export function standardizedCityName(cityName: string): string {
  if (!cityName) return '';
  const normalized = cityName.trim().toLowerCase();
  if (normalized === 'saint catharines' || normalized === 'saint catherines') {
    return 'St. Catharines';
  }
  
  return capitalizeWords(cityName);
}

/**
 * Standardizes casing on a leading (pre-comma) segment, but only when that
 * segment is actually all lower-case. That guard is what makes this safe to
 * apply broadly: the live popular-cities insights API returns city names
 * lower-cased (e.g. "toronto, ON") and needs fixing, but a well-cased
 * location/address/school description (e.g. "McKellar, ON", "P.S. 41, New
 * York, NY") must be left untouched — standardizedCityName lower-cases the
 * whole segment before re-capitalizing each word's first letter, which would
 * otherwise destroy any existing internal capitalization ("McKellar" ->
 * "Mckellar").
 */
export function capitalizeLeadingSegmentIfLowercase(segment: string): string {
  const trimmed = segment.trim();
  return trimmed === trimmed.toLowerCase() ? standardizedCityName(trimmed) : trimmed;
}

/**
 * The live popular-cities insights API returns city names lower-cased
 * (e.g. "toronto, ON") — standardize the city portion, keep the
 * province/state code as-is.
 */
export function formatCityProvinceLabel(label: string): string {
  const [city, provinceOrState] = label.split(',');
  const formattedCity = capitalizeLeadingSegmentIfLowercase(city);
  if (!provinceOrState) return formattedCity;
  return `${formattedCity}, ${provinceOrState.trim().toUpperCase()}`;
}
